import {API} from '@/services/api/api';
import {mergeBase64toImage} from '@/services/api/image';

export const setAppLogo = async (fnCall, logoId) => {
  try {
    const res = await API.getLogoDetailsById(logoId);
    if (res.data) {
      const data = res.data;
      const image = mergeBase64toImage(data.imageType, data.logoImage);

      fnCall(image);
    } else {
      fnCall(null);
    }
  } catch (e) {
    console.error(e);
  }
};

export const getShipList = async () => {
  try {
    const response = await API.fetchShipList();
    if (response?.data) {
      const data = response?.data;

      return response;
    }
  } catch (e) {
    console.error(e);
  }
};

export const getAllowedShipListForRole = async () => {
  try {
    const response = await API.fetchAllowedShipListForRole();
    if (response?.data) {
      const data = response?.data;

      return response;
    }
  } catch (e) {
    console.error(e);
  }
};

export const getShipFromVOP = async () => {
  try {
    const response = await API.snycShipsFromVOP();
    if (response?.data) {
      const data = response?.data;

      return response;
    }
  } catch (e) {
    console.error(e);
  }
};
